import Vue from 'vue';
import language from './language-payment-receipt-1.0.0';

/**
 * El número de versión del componente se encuentra en las constantes,
 * bajo el nombre de PAYMENT_RECEIPT_VERSION
 * 
 * Este componente cumple dos funcionalidades:
 * - un formulatio para ingresar un xml de complemento de pagos y un pdf relacionado
 * - mostrar detalles de un complemento de pago, permitiendo solo cambiar el pdf
 * 
 * Requier de las siguientes propiedades para funcionar:
 * - General:
 *      ~ payment: pago para encontrar relaciones.
 *      ~ toastr: se debe crear un metodo que retorne un objeto toast. (Debe de estar asignado en vueApp)
 *      ~ formatMoney: se debe crear un metodo que retorna una funcion formatMoney. (Debe de estar asignado en vueApp)
 *      ~ currencyUrl: ruta para obtener las divisas de base de datos.
 *      ~ jasny: para manejar input de archivos y nombres.
 *      ~ sweetalert2: para manejo de alertas de confirmación.
 *      ~ moment: para formateo de fechas.
 * - Formulario:
 *      ~ invoice: relacionada al pago.
 *      ~ saveUrl: url para guardar el complemento de pago y su relación con el pago y factura.
 *      ~ validateUrl: url para validar el complemento de pago y encontrar si ya existe.
 * - Detalle:
 *      ~ updateUrl: url para actualizar el pdf.
 *      ~ deleteUrl: url para eliminar la relación del pago y factura/as del complemento de pago.
 *      ~ paymentReceiptDataUrl: url para obtener el complemento de pago y llenar la información del detalle.
 *      ~ downloadFile: función para descargar los los archivos
 *      ~ previewFile: función para previsualizar archivo pdf
 *      ~ canDelete: booleano para avilitar la opción de eliminar el complemento de pago
 * 
 * PORTAL DE PROVEEDORES
 *  ¡ATENCIÓN!
 *      descomentar los import
 *      descommentar la constante desde conts hasta el signo =
 *      descomentar la linea de export default, los mismo para el archivo language-payment-receipt.js 
 * SCOT_ADMIN
 *  comentar los import
 *  commentar la constante desde conts hasta el signo =
 *  comentar la linea de export default, los mismo para el archivo language-payment-receipt.js 
 */

const local = localStorage.getItem('language') ? localStorage.getItem('language') : 'es';

const paymentReceiptModalComponent = Vue.component('payment-receipt-modal-component', {
    delimiters: ['$|', '|'],
    template: `<div class="modal-body mt-2">
                    <div class="text-right" v-show="isShow && !showAlert">
                        <button class="btn btn-default btn-actions" @click="previewFile(paymentReceipt.pdf.encryptedName, true, true)">
                            <i class="fa fa-eye"></i> ${ language[local].preview } PDF
                        </button>
                        <button id="download-xml-file" class="btn btn-default btn-actions" @click="downloadFile(paymentReceipt.xml.encryptedName, paymentReceipt.xml.name, true)">
                            <i class="fa fa-download"></i> ${ language[local].download } XML
                        </button>
                        <button id="download-pdf-file" class="btn btn-default btn-actions" @click="downloadFile(paymentReceipt.pdf.encryptedName,paymentReceipt.pdf.name, true)">
                            <i class="fa fa-download"></i> ${ language[local].download } PDF
                        </button>
                        <button class="btn btn-primary btn-actions" @click="editPDF">
                            <i :class="['fa', canEditPDF ? 'fa-floppy-o': 'fa-pencil']"></i> $| canEditPDF ? '${ language[local].save } PDF' : '${ language[local].edit } PDF' |
                        </button>
                        <button class="btn btn-danger btn-actions" @click="deletePaymentReceipt" v-show="canDelete">
                            <i class="fa fa-chain-broken"></i> ${ language[local].delete } CDP
                        </button>
                    </div>
                    
                    <form id="payment-receipt-form">
                        <div class="row" id="payment-receipt-file-input-focus">
                            <div class="col-lg-6">
                                <div class="form-group">
                                    <label>${ language[local].xmlFile }:</label>
                                    <div class="fileinput fileinput-new input-group jasny-input-group" data-provides="fileinput">
                                        <div :class="['form-control', 'text-left', {'is-invalid':formError.xmlFile}]" data-trigger="fileinput" :style="{ backgroundColor: isShow ? '#eeeeee' : '' }">
                                            <span id="payment-receipt-xml-file-name" class="fileinput-filename"></span>
                                        </div>

                                        <span class="input-group-addon btn btn-file btn-actions">
                                            <span class="fileinput-new"><i class="fa fa-file"></i></span>
                                            <span class="fileinput-exists"><i class="fa fa-file"></i></span>
                                            <input type="text" class="jasny-file-input" autocomplete="off" title="Archivo XML">
                                            <input 
                                                id="payment-receipt-xml-file-input"
                                                name="payment-receipt-xml-file"
                                                type="file" accept=".xml" 
                                                class="btn-actions" 
                                                @click="preventFileBrowser" 
                                                @change="paymentReceiptXmlFileChange">
                                        </span>
                                    </div>
                                    <label class="text-danger" v-show="formError.xmlFile">${ language[local].selectFile } XML</label>
                                </div>
                            </div>

                            <div class="col-lg-6">
                                <div class="form-group">
                                    <label>${ language[local].pdfFile }:</label>
                                    <div class="fileinput fileinput-new input-group jasny-input-group" data-provides="fileinput">
                                        <div :class="['form-control', 'text-left', {'is-invalid':formError.pdfFile}]" data-trigger="fileinput" 
                                            :style="{ backgroundColor: (isShow && !canEditPDF) ? '#eeeeee' : '' }">
                                            <span id="payment-receipt-pdf-file-name" class="fileinput-filename"></span>
                                        </div>

                                        <span class="input-group-addon btn btn-file btn-actions">
                                            <span class="fileinput-new"><i class="fa fa-file"></i></span>
                                            <span class="fileinput-exists"><i class="fa fa-file"></i></span>
                                            <input type="text" class="jasny-file-input" autocomplete="off" title="Archivo PDF">
                                            <input 
                                                id="payment-receipt-pdf-file-input"
                                                name="payment-receipt-pdf-file"
                                                type="file" accept=".pdf" 
                                                class="btn-actions" 
                                                @click="preventFileBrowser">
                                        </span>
                                    </div>
                                    <label class="text-danger" v-show="formError.pdfFile">${ language[local].selectFile } PDF</label>
                                </div>
                            </div>
                        </div>
                    </form>

                    <div id="payment-receipt-error-alert" style="border-left: 5px solid #d70000" class="alert alert-danger" role="alert" v-show="showAlert">
                        <h4 class="alert-heading">$| optionAlert.title |</h4>
                        <p v-html="optionAlert.message"></p>
                    </div>
                    <div id="payment-receipt-warning-alert" class="alert alert-warning" role="alert" v-show="showWarningAlert">
                        <h4 class="alert-heading">$| optionAlert.title |</h4>
                        <p v-html="optionAlert.message"></p>
                    </div>

                    <div v-show="hasValidXmlFile">
                        <div class="table-responsive">
                            <table id="xml-content-table" class="table table-bordered">
                                <thead>
                                    <tr>
                                        <th colspan="4" style="background-color: #e5e6e7;">${ language[local].fileContent }</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th colspan="4"><strong>UUID</strong></th>
                                    </tr>
                                    <tr>
                                        <td colspan="4">$| paymentReceipt.uuid |</td>
                                    </tr>

                                    <tr>
                                        <th><strong>${ language[local].serial }</strong></th>
                                        <th><strong>${ language[local].folio }</strong></th>
                                        <th><strong>${ language[local].created }</strong></th>
                                        <th><strong>${ language[local].voucherType }</strong></th>
                                    </tr>
                                    <tr>
                                        <td>$| paymentReceipt.serial |</td>
                                        <td>$| paymentReceipt.folio |</td>
                                        <td>$| paymentReceipt.created |</td>
                                        <td>$| paymentReceipt.voucherType | ($| getVoucherTypeName(paymentReceipt.voucherType) |)</td>
                                    </tr>

                                    <tr>
                                        <th class="text-right"><strong>${ language[local].subTotal }</strong></th>
                                        <th class="text-center"><strong>${ language[local].currency }</strong></th>
                                        <th class="text-right"><strong>${ language[local].total }</strong></th>
                                        <th class="text-right"><strong>${ language[local].placeExpedition }</strong></th>
                                    </tr>
                                    <tr>
                                        <td class="text-right">$ $| formatMoney(paymentReceipt.subTotal, 2, [',', ',', '.']) |</td>
                                        <td class="text-center">$| paymentReceipt.currency |</td>
                                        <td class="text-right"> $ $| formatMoney(paymentReceipt.total, 2, [',', ',', '.']) |</td>
                                        <td class="text-right">$| paymentReceipt.placeExpedition |</td>
                                    </tr>

                                    <tr>
                                        <th colspan="2"><strong>${ language[local].issuing }</strong></th>
                                        <th colspan="2"><strong>${ language[local].recipient }</strong></th>
                                    </tr>
                                    <tr>
                                        <td colspan="2">
                                            <span><strong>${ language[local].name }:</strong> $| paymentReceipt.issuing.name |</span>
                                            <br>
                                            <span><strong>${ language[local].taxId }:</strong> $| paymentReceipt.issuing.taxId |</span>
                                        </td>
                                        <td colspan="2">
                                            <span><strong>${ language[local].name }:</strong> $| paymentReceipt.recipient.name |</span>
                                            <br>
                                            <span><strong>${ language[local].taxId }:</strong> $| paymentReceipt.recipient.taxId |</span>
                                        </td>
                                    </tr>

                                    <tr>
                                        <th class="text-right" colspan="2"><strong>${ language[local].totals }</strong></th>
                                        <th class="text-right" colspan="2"><strong></strong></th>
                                    </tr>
                                    <tr>
                                        <td class="text-right" colspan="2">$ $| formatMoney(paymentReceipt.totals, 2, [',', ',', '.']) |</td>
                                        <td class="text-right" colspan="2"></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div v-for="(relatedPayment, index) in paymentReceipt.relatedPayments">
                            <div class="table-responsive">
                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th colspan="8" style="background-color: #e5e6e7;"><strong>${ language[local].payment } #$| index + 1 |</strong></th>
                                        </tr>
                                        <tr>
                                            <th colspan="2"><strong>${ language[local].paymentDate }</strong></th>
                                            <th colspan="2" class="text-right"><strong>${ language[local].paymentWay }</strong></th>
                                            <th colspan="2" class="text-center"><strong>${ language[local].currency }</strong></th>
                                            <th colspan="2" class="text-right"><strong>${ language[local].amount }</strong></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr :style="[relatedPayment.isSelected ? {backgroundColor: '#ecffed'} : {}, 
                                                    relatedPayment.error ? {backgroundColor: '#fcebeb'} : {}]">
                                            <td colspan="2">$| relatedPayment.paymentDate |</td>
                                            <td colspan="2" class="text-right">$| relatedPayment.paymentWay |</td>
                                            <td colspan="2" class="text-center">$| relatedPayment.currency.code |</td>
                                            <td colspan="2" class="text-right">
                                                $| relatedPayment.currency.symbol | $| formatMoney(relatedPayment.amount, 2, [',', ',', '.']) |
                                            </td>
                                        </tr>
                                        <tr>
                                            <th colspan="8" style="background-color: #eeeeee;"><strong>${ language[local].relatedDocuments }</strong></th>
                                        </tr>
                                        <tr>
                                            <th style="background-color: #eeeeee"><strong>UUID</strong></th>
                                            <th style="background-color: #eeeeee"><strong>${ language[local].serial }</strong></th>
                                            <th style="background-color: #eeeeee" class="text-center"><strong>${ language[local].folio }</strong></th>
                                            <th style="background-color: #eeeeee" class="text-center"><strong>${ language[local].currency }</strong></th>
                                            <th style="background-color: #eeeeee" class="text-right"><strong>${ language[local].previousBalanceAmount }</strong></th>
                                            <th style="background-color: #eeeeee" class="text-right"><strong>${ language[local].amountPaid }</strong></th>
                                            <th style="background-color: #eeeeee" class="text-right"><strong>${ language[local].outstandingBalanceAmount }</strong></th>
                                            <th style="background-color: #eeeeee" class="text-center">${ language[local].status }</th>
                                        </tr>
                                        <tr v-for="document in relatedPayment.relatedDocuments" :style="(relatedPayment.isSelected && document.isSelected) ? {backgroundColor: '#ecffed'} : {}">
                                            <td>$| document.idDocument |</td>
                                            <td>$| document.serial |</td>
                                            <td class="text-center">$| document.folio |</td>
                                            <td class="text-center">$| document.currency.code |</td>
                                            <td class="text-right">
                                                $| document.currency.symbol | $| formatMoney(document.previousBalanceAmount, 2, [',', ',', '.']) |
                                            </td>
                                            <td class="text-right">
                                                $| document.currency.symbol | $| formatMoney(document.amountPaid, 2, [',', ',', '.']) |
                                            </td>
                                            <td class="text-right">
                                                $| document.currency.symbol | $| formatMoney(document.outstandingBalanceAmount, 2, [',', ',', '.']) |
                                            </td>
                                            <td class="text-center">
                                                <span :style="[document.isAvailable ? badgeSecondary : '']" :class="['badge', document.isAvailable ? '' : 'badge-success']">
                                                    $| document.isAvailable ? '${ language[local].noRelated }' : '${ language[local].related }' |
                                                </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div class="table-responsive" v-if="!isShow && paymentReceipt.relatedPayments.length > 0">
                            <table class="table table-bordered">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>${ language[local].invoice } / ${ language[local].payment }</th>
                                        <th>CDP / ${ language[local].relatedDocument }</th>
                                        <th class="text-center">${ language[local].validation }</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td><strong>UUID ${ language[local].invoice }</strong></td>
                                        <td>$| invoice.uuid |</td>
                                        <td>$| relatedDocument.idDocument |</td>
                                        <td class="text-center">
                                            <i :class="['fa', validateInvoiceUuid ? 'fa-check text-success': 'fa-times text-danger' ]"></i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><strong>${ language[local].serial }</strong></td>
                                        <td>$| invoice.serial |</td>
                                        <td>$| relatedDocument.serial |</td>
                                        <td class="text-center">
                                            <i :class="[ 'fa', validateInvoiceSerial ? 'fa-check text-success': 'fa-exclamation-triangle text-warning' ]"></i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><strong>${ language[local].folio }</strong></td>
                                        <td>$| invoice.folio |</td>
                                        <td>$| relatedDocument.folio |</td>
                                        <td class="text-center">
                                            <i :class="['fa', validateInvoiceFolio ? 'fa-check text-success': 'fa-exclamation-triangle text-warning' ]"></i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><strong>${ language[local].paymentDate }</strong></td>
                                        <td>$| payment.paymentDate |</td>
                                        <td>$| relatedPayment.paymentDate |</td>
                                        <td class="text-center">
                                            <i :class="[, 'fa', validatePaymentDate ? 'fa-check text-success' : 'fa-times text-danger' ]"></i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><strong>${ language[local].amount }</strong></td>
                                        <td>
                                            $| payment.currency.symbol| $| formatMoney(payment.amount, 2, [',', ',', '.']) |
                                        </td>
                                        <td>
                                            $| relatedDocument.currency.symbol| $| relatedDocument.amountPaid != null ? formatMoney(relatedDocument.amountPaid, 2, [',', ',', '.']) : '' |
                                        </td>
                                        <td class="text-center">
                                            <i :class="['fa', validatePaymentAmount ? 'fa-check text-success': 'fa-times text-danger' ]"></i>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><strong>${ language[local].currency }</strong></td>
                                        <td>$| payment.currency.code |</td>
                                        <td>$| relatedDocument.currency.code |</td>
                                        <td class="text-center">
                                            <i :class="['fa', validatePaymentCurrency ? 'fa-check text-success': 'fa-times text-danger' ]"></i>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>`,
    props: {
        isShow: {
            type: Boolean,
            default: false,
            required: true
        },
        payment: {
            type: Object,
            default: () => ({
                amountPaid: '',
                paymentDate: '',
                currency: {
                    code: ''
                }
            }),
            required: true
        },
        invoice: {
            type: Object,
            default: () => ({
                uuid: '',
                serial: '',
                folio: ''
            })
        },
        toastr: {
            type: Function,
            required: false
        },
        currencyUrl: {
            type: String,
            required: true
        },
        saveUrl: {
            type: String,
            required: false
        },
        updateUrl: {
            type: String,
            required: false
        },
        deleteUrl: {
            type: String,
            required: false
        },
        validateUrl: {
            type: String,
            required: false
        },
        paymentReceiptDataUrl: {
            type: String,
            required: false
        },
        formatMoney: {
            type: Function,
            required: true
        },
        downloadFile: {
            type: Function,
            required: false
        },
        previewFile: {
            type: Function,
            required: false
        },
        canDelete: {
            type: Boolean,
            default: false,
            required: true
        }
    },
    data() {
        return {
            hasValidXmlFile: false,
            canEditPDF: false,
            paymentReceiptExists: false,
            hasRelatedPayment: false,
            canCreate: false,
            paymentReceiptEntity: {
                id: 0,
                uuid: '',
                cfdiUse: '',
                invoiced: '',
                version: '',
                stamp: '',
                serial: '',
                folio: '',
                created: '',
                certificateNumber: '',
                certificate: '',
                voucherType: '',
                subTotal: '',
                currency: '',
                total: '',
                placeExpedition: 0,
                issuing: {
                    taxId: '',
                    name: ''
                },
                recipient: {
                    taxId: '',
                    name: ''
                },
                totals: '',
                payment: '',
                paymentCurrency: {
                    id: 0,
                    code: '',
                    symbol: ''
                },
                paymentDate: '',
                paymentWay: '',
                paymentMethod: 'PPD',
                paymentAccountNumber: '',
                relatedTotal: 0,
                relatedAmount: 0,
                balanceToRelated: 0,
                requiresXmlFile: true,
                documentType: 'PaymentReceipt',
                invoice: '',
                notes: '',
                exchangeRate: '0.0000',
                userExchangeRate: '0.0000',
                estimatedPaymentDate: '',
                isAdvance: '',
                relatedPayments: [],
                entityVersion: 1
            },
            relatedDocumentEntity: {
                idDocument: '',
                serial: '',
                folio: null,
                currency: {
                    id: 0,
                    code: '',
                    symbol: ''
                },
                previousBalanceAmount: '',
                amountPaid: null,
                outstandingBalanceAmount: '',
                isSelected: false,
                isAvailable: true
            },
            relatedPaymentEntity: {
                paymentId: 0,
                paymentDate: '',
                paymentWay: '',
                amount: 0,
                currency: {
                    id: 0,
                    code: '',
                    symbol: ''
                },
                relatedDocuments: [],
                isSelected: false,
                isAvailable: true
            },
            paymentReceipt: {},
            relatedDocument: {},
            relatedPayment: {},
            attributesMapPaymentReceipt: [
                { key: 'uuid', code: 'uuid' },
                { key: 'fecha', code: 'invoiced' },
                { key: 'sello', code: 'stamp' },
                { key: 'version', code: 'version' },
                { key: 'nocertificado', code: 'certificateNumber' },
                { key: 'certificado', code: 'certificate' },
                { key: 'serie', code: 'serial' },
                { key: 'folio', code: 'folio' },
                { key: 'fechatimbrado', code: 'created' },
                { key: 'tipodecomprobante', code: 'voucherType' },
                { key: 'subtotal', code: 'subTotal' },
                { key: 'moneda', code: 'currency' },
                { key: 'total', code: 'total' },
                { key: 'lugarexpedicion', code: 'placeExpedition' },
                { key: 'nombre', code: 'name' },
                { key: 'rfc', code: 'taxId' },
                { key: 'usocfdi', code: 'cfdiUse' },
                { key: 'montototalpagos', code: 'totals' },
                { key: 'monto', code: 'payment' },
                { key: 'fechapago', code: 'paymentDate' }
            ],
            attributesMapRelatedDocument: [
                { key: 'iddocumento', code: 'idDocument' },
                { key: 'serie', code: 'serial' },
                { key: 'folio', code: 'folio' },
                { key: 'impsaldoant', code: 'previousBalanceAmount' },
                { key: 'imppagado', code: 'amountPaid' },
                { key: 'impsaldoinsoluto', code: 'outstandingBalanceAmount' },
                { key: 'monedadr', code: 'currency' }
            ],
            attributesMapRelatedPayment: [
                { key: 'fechapago', code: 'paymentDate' },
                { key: 'formadepagop', code: 'paymentWay' },
                { key: 'monto', code: 'amount' },
                { key: 'monedap', code: 'currency' }
            ],
            formError: {
                xmlFile: false,
                pdfFile: false
            },
            swalButtonColor: '#45C066',
            optionAlert: {
                title: '',
                message: ''
            },
            showAlert: false,
            badgeSecondary: {
                backgroundColor: '#8b8e91 !important',
                color: '#fff !important',
                border: '1px #6c757d solid !important',
                transition: 'var(--c-transition-time)'
            },
            currencies: [],
            action: 'CREATE',
            showWarningAlert: false
        };
    },
    created() {
        let $this = this;
        this.paymentReceipt = JSON.parse(JSON.stringify(this.paymentReceiptEntity));
        this.relatedDocument = JSON.parse(JSON.stringify(this.relatedDocumentEntity));
        this.relatedPayment = JSON.parse(JSON.stringify(this.relatedPaymentEntity));

        $.ajax({
            url: $this.currencyUrl,
            method: 'GET',
            success(response) {
                if (response.code === 'OK') {
                    $this.currencies = response.currencies;
                }
            },
            error(xhr) {
                if (xhr.status == 401) {
                    toastr.error(`${ language[local].accessUnauthorized }, ${ language[local].reloadThePage }`, language[local].anErrorHasOccurred);
                } else {
                    toastr.error(language[local].tryAgainError, language[local].anErrorHasOccurred);
                }
            }
        });
    },
    mounted() {
        let $this = this;
        $('#xml-content-table tbody th').css('backgroundColor', '#eeeeee');

        $('#payment-receipt-modal').on('hidden.bs.modal', () => {
            $this.relatedDocument = JSON.parse(JSON.stringify($this.relatedDocumentEntity));
            $this.relatedPayment = JSON.parse(JSON.stringify($this.relatedPaymentEntity));
            $this.hasRelatedPayment = false;
            $this.paymentReceiptExists = false;
            
            this.showAlert = false;
            this.showWarningAlert = false;

            $this.paymentReceiptXmlFileClear();
            $('#payment-receipt-pdf-file-input').val(null);
            $('#payment-receipt-pdf-file-name').text('');
            $this.formError = {
                xmlFile: false,
                pdfFile: false
            };
        });

        $('#payment-receipt-modal').on('show.bs.modal', () => {
            $this.$nextTick(() => {
                if ($this.isShow) {
                    $.ajax({
                        url: $this.paymentReceiptDataUrl.replace('PLACEHOLDER', $this.payment.id),
                        method: 'GET',
                        async: false,
                        success(response) {
                            if (response.code === 'OK' && response.exists) {
                                $this.paymentReceipt = JSON.parse(JSON.stringify(response.paymentReceipt));
                            } else if (response.code === 'NOK') {
                                toastr.warning(`${ language[local].paymentReceiptNoExists }, ${ language[local].reloadThePage }`, language[local].attention);

                                $this.showAlertMessage(language[local].anErrorHasOccurred, `${ language[local].paymentReceiptNoExists }, ${ language[local].reloadThePage }`, 'warning');
                            }
                        },
                        error(xhr) {
                            if (xhr.status == 401) {
                                toastr.error(`${ language[local].accessUnauthorized }, ${ language[local].reloadThePage }`, language[local].anErrorHasOccurred);
                            } else {
                                toastr.error(language[local].tryAgainError, language[local].anErrorHasOccurred);
                            }
                        }
                    });

                    $this.getPaymentAndInvoice();
                } else {
                    $this.paymentReceiptXmlFileClear();

                    $('#payment-receipt-pdf-file-input').val(null);
                    $('#payment-receipt-pdf-file-name').text('');
                }
            });
        });
    },
    methods: {
        preventFileBrowser(event) {
            if (this.isShow) {
                if ($(event.target).attr('id') !== 'payment-receipt-pdf-file-input') {
                    event.preventDefault();
                } else if (!this.canEditPDF) {
                    event.preventDefault();
                }
            }
        },
        editPDF() {
            if (this.canEditPDF) {
                this.updatePdfFile();
            }

            this.canEditPDF = !this.canEditPDF;
        },
        paymentReceiptXmlFileClear() {
            let $this = this;

            this.paymentReceipt = JSON.parse(JSON.stringify($this.paymentReceiptEntity));
            this.relatedDocument = JSON.parse(JSON.stringify($this.relatedDocumentEntity));
            this.relatedPayment = JSON.parse(JSON.stringify($this.relatedPaymentEntity));
            this.hasValidXmlFile = false;
            this.hasRelatedPayment = false;

            this.optionAlert = {
                title: '',
                message: ''
            },
            
            this.showAlert = false;

            $('#payment-receipt-xml-file-input').val(null);
            $('#payment-receipt-xml-file-name').text('');
        },
        paymentReceiptXmlFileChange() {
            let $this = this;
            let $xmlFileInput = $('#payment-receipt-xml-file-input');
            let $btnActions = $('.btn-actions');

            this.paymentReceipt = JSON.parse(JSON.stringify($this.paymentReceiptEntity));
            this.relatedDocument = JSON.parse(JSON.stringify($this.relatedDocumentEntity));
            this.relatedPayment = JSON.parse(JSON.stringify($this.relatedPaymentEntity));

            $btnActions.prop('disabled', true);

            if ($xmlFileInput.val() !== '') {
                let xmlFile = $xmlFileInput[0].files[0];

                if (xmlFile.type !== 'text/xml') {
                    this.paymentReceiptXmlFileClear();

                    this.showAlertMessage(language[local].attention, language[local].incorrectDocument, 'warning');
                } else {
                    let fileReader = new FileReader();

                    fileReader.onload = async function(event) {
                        try {
                            $this.showAlert = false;
                            $this.optionAlert = {
                                title: '',
                                message: ''
                            };
                            let xmlContent = new DOMParser().parseFromString(event.target.result.toString(), 'text/xml');
                            let voucher = $(xmlContent).find('cfdi\\:Comprobante');
                            let voucherType = voucher[0].attributes.TipoDeComprobante.value;

                            if (voucherType=== 'P') {

                                $.each($(xmlContent).find('cfdi\\:Emisor')[0].attributes, (index, attribute) => {
                                    let name = attribute.name.toLowerCase();
                                    let attrMap = $this.attributesMapPaymentReceipt.find(attr => attr.key === name);

                                    if (attrMap) {
                                        let code = attrMap.code;

                                        $this.paymentReceipt.issuing[code] = attribute.value;
                                    }
                                });

                                $.each($(xmlContent).find('cfdi\\:Receptor')[0].attributes, (index, attribute) => {
                                    let name = attribute.name.toLowerCase();
                                    let attrMap = $this.attributesMapPaymentReceipt.find(attr => attr.key === name);

                                    if (attrMap) {
                                        let code = attrMap.code;

                                        if (name == 'usocfdi') {
                                            $this.paymentReceipt[code] = attribute.value;
                                        } else {
                                            $this.paymentReceipt.recipient[code] = attribute.value;
                                        }
                                    }
                                });

                                if (!$this.validateRecipientData) {
                                    $this.showAlertMessage(language[local].attention, language[local].incorrectRecipientData, 'warning');
                                } else if (!$this.validateIssuingData) {
                                    $this.showAlertMessage(language[local].attention, language[local].incorrectIssuingData, 'warning');
                                }

                                $.each($(xmlContent).find('tfd\\:TimbreFiscalDigital')[0].attributes, (index, attribute) => {
                                    let name = attribute.name.toLowerCase();
                                    let attrMap = $this.attributesMapPaymentReceipt.find(attr => attr.key === name);

                                    if (attrMap) {
                                        let code = attrMap.code;

                                        if (name == 'fechatimbrado') {
                                            $this.paymentReceipt[code] = moment(attribute.value).format('YYYY-MM-DD HH:mm:ss');
                                        } else {
                                            $this.paymentReceipt[code] = attribute.value;
                                        }
                                    }
                                });

                                await $this.paymentReceiptValidator($this.paymentReceipt.uuid);

                                if (!$this.paymentReceiptExists && $this.canCreate) {
                                    $.each($(voucher)[0].attributes, (index, attribute) => {
                                        let name = attribute.name.toLowerCase();
                                        let attrMap = $this.attributesMapPaymentReceipt.find(attr => attr.key === name);

                                        if (attrMap) {
                                            let code = attrMap.code;

                                            if (name == 'lugarexpedicion') {
                                                $this.paymentReceipt[code] = parseInt(attribute.value);
                                            } else if (name == 'fecha') {
                                                $this.paymentReceipt[code] = moment(attribute.value).format('YYYY-MM-DD HH:mm:ss');
                                            } else {
                                                $this.paymentReceipt[code] = attribute.value;
                                            }
                                        }
                                    });

                                    $this.paymentReceipt.invoice =  $this.paymentReceipt.serial + $this.paymentReceipt.folio;

                                    let doctoRelacionado = $(xmlContent).find(`pago20\\:DoctoRelacionado[IdDocumento=${$this.invoice.uuid}]`);

                                    if (!doctoRelacionado) {
                                        $this.showAlertMessage(language[local].attention, language[local].relatedDocumentError, 'warning');
                                    }

                                    $.each($(xmlContent).find('pago20\\:Totales')[0].attributes, (index, attribute) => {
                                        let name = attribute.name.toLowerCase();
                                        let attrMap = $this.attributesMapPaymentReceipt.find(attr => attr.key === name);

                                        if (attrMap) {
                                            let code = attrMap.code;

                                            if (name == 'montototalpagos') {
                                                $this.paymentReceipt[code] = parseFloat(attribute.value);
                                            }
                                        }
                                    });

                                    let incorrectDate = false;

                                    $.each($(xmlContent).find('pago20\\:Pago'), (index, relatedPayment) => {
                                        let payment = JSON.parse(JSON.stringify($this.relatedPaymentEntity));

                                        $.each($(relatedPayment)[0].attributes, (index, attribute) => {
                                            let name = attribute.name.toLowerCase();
                                            let attrMap = $this.attributesMapRelatedPayment.find(attr => attr.key === name);

                                            if (attrMap) {
                                                let code = attrMap.code;

                                                if (name == 'fechapago') {
                                                    if (new Date($this.paymentReceipt.created) < new Date(attribute.value)) {
                                                        $this.canCreate = false;
                                                        incorrectDate = true;
                                                        payment.error = true;
                                                    }

                                                    payment[code] = moment(attribute.value).format('YYYY-MM-DD');
                                                } else if (name == 'monto') {
                                                    payment[code] = parseFloat(attribute.value);
                                                } else if (name == 'monedap') {
                                                    let currency = $this.currencies.find(currency => currency.code === attribute.value);

                                                    payment.currency = {
                                                        id: currency.id,
                                                        code: attribute.value,
                                                        symbol: currency.symbol
                                                    };
                                                } else {
                                                    payment[code] = attribute.value;
                                                }
                                            }
                                        });

                                        $.each($(relatedPayment)[0].children, (index, relatedDoc) => {
                                            if ($(relatedDoc)[0].nodeName == 'pago20:DoctoRelacionado') {
                                                let relatedDocument = JSON.parse(JSON.stringify($this.relatedDocumentEntity));

                                                $.each($(relatedDoc)[0].attributes, (index, attribute) => {
                                                    let name = attribute.name.toLowerCase();
                                                    let attrMap = $this.attributesMapRelatedDocument.find(attr => attr.key === name);

                                                    if (attrMap) {
                                                        let code = attrMap.code;

                                                        if (name == 'folio') {
                                                            relatedDocument[code] = parseInt(attribute.value);
                                                        } else if (['impsaldoant', 'imppagado', 'impsaldoinsoluto'].includes(name)) {
                                                            relatedDocument[code] = parseFloat(attribute.value);
                                                        } else if (name == 'monedadr') {
                                                            let currency = $this.currencies.find(currency => currency.code === attribute.value);

                                                            relatedDocument.currency = {
                                                                id: currency.id,
                                                                code: attribute.value,
                                                                symbol: currency.symbol
                                                            };
                                                        } else {
                                                            relatedDocument[code] = attribute.value;
                                                        }
                                                    }
                                                });

                                                if ((relatedDocument.amountPaid == $this.payment.amount) && (relatedDocument.idDocument === $this.invoice.uuid) && !$this.hasRelatedPayment) {
                                                    relatedDocument.isSelected = true;
                                                    $this.paymentReceipt.relatedAmount = relatedDocument.amountPaid;
                                                    $this.relatedDocument = JSON.parse(JSON.stringify(relatedDocument));

                                                    payment.isSelected = true;
                                                    payment.paymentId = $this.payment.id;
                                                    $this.relatedPayment = JSON.parse(JSON.stringify(payment));
                                                    $this.hasRelatedPayment = true;
                                                }

                                                payment.relatedDocuments.push(relatedDocument);
                                            }
                                        });

                                        $this.paymentReceipt.relatedPayments.push(payment);
                                    });

                                    if (!$this.hasRelatedPayment && !incorrectDate) {
                                        $this.showAlertMessage(language[local].attention, `${ language[local].relatedPaymentError }`, 'warning');
                                    } else if (incorrectDate) {
                                        $this.showAlertMessage(language[local].attention, `${ language[local].relatedPaymentDateError }`, 'warning');
                                    }
                                }
                            } else {
                                $this.paymentReceiptXmlFileClear();
                                $this.showAlertMessage(language[local].attention, `${language[local].voucherTypeError(voucherType, $this.getVoucherTypeName(voucherType))}`, 'warning');
                            }
                        } catch (error) {
                            $this.paymentReceiptXmlFileClear();

                            if (!error.code) {
                                toastr.error(`${ language[local].tryAgainError }.`, language[local].anErrorHasOccurred);
                            }
                        }
                    };

                    fileReader.readAsText(xmlFile);
                }
            }

            $btnActions.removeAttr('disabled');
        },
        submitPaymentReceiptForm() {
            let $this = this;
            let formData = new FormData();
            let $btnActions = $('.btn-actions');
            $btnActions.prop('disabled', true);

            if ($this.canCreate) {
                if (!this.paymentReceiptExists) {
                    let $xmlFile = $('#payment-receipt-xml-file-input')[0].files[0];
                    let $pdfFile = $('#payment-receipt-pdf-file-input')[0].files[0];

                    if (!$xmlFile || $xmlFile.type !== 'text/xml') {
                        this.formError.xmlFile = true;
                        $btnActions.removeAttr('disabled');
                    } else {
                        this.formError.xmlFile = false;

                        formData.append('xmlFile[name]', $xmlFile.name);
                        formData.append('xmlFile[size]', $xmlFile.size);
                        formData.append('xmlFile[file]', $xmlFile);
                    }

                    if (!$pdfFile || $pdfFile.type !== 'application/pdf') {
                        this.formError.pdfFile = true;
                        $btnActions.removeAttr('disabled');
                    } else {
                        this.formError.pdfFile = false;

                        formData.append('pdfFile[name]', $pdfFile.name);
                        formData.append('pdfFile[size]', $pdfFile.size);
                        formData.append('pdfFile[file]', $pdfFile);
                    }
                }

                if (!this.formError.xmlFile && !this.formError.pdfFile) {
                    let relatedPayment = $this.paymentReceipt.relatedPayments.find(relatedPayment => relatedPayment.paymentId == $this.payment.id);

                    if (this.paymentReceiptExists) {
                        let relatedDocument = relatedPayment.relatedDocuments.find(relatedDocument => relatedDocument.idDocument == $this.invoice.uuid);
                        relatedPayment.isAvailable = false;
                        relatedDocument.isAvailable = false;

                        Vue.delete(relatedDocument, 'isSelected');
                        Vue.delete(relatedPayment, 'isSelected');
                    } else {
                        relatedPayment.relatedDocuments.forEach(document => {
                            if (document.idDocument === $this.invoice.uuid) {
                                relatedPayment.isAvailable = false;
                                document.isAvailable = false;
                            }

                            Vue.delete(document, 'isSelected');
                            Vue.delete(relatedPayment, 'isSelected');
                        });
                    }

                    formData.append('invoice', JSON.stringify($this.paymentReceipt));
                    formData.append('orderType', 'Payment');
                    formData.append('orderId', $this.payment.id);
                    formData.append('relatedInvoiceData', JSON.stringify({ id: $this.invoice.id, uuid: $this.invoice.uuid }));
                    formData.append('action', $this.action);

                    $.ajax({
                        url: $this.saveUrl,
                        method: 'POST',
                        data: formData,
                        contentType: false,
                        processData: false,
                        success(response) {
                            if (response.code === 'OK') {
                                toastr.success(language[local].saveSuccessfully);
                                window.location.reload();
                            } else if (response.code === 'NOK') {
                                if (this.paymentReceiptExists) {
                                    let relatedDocument = relatedPayment.relatedDocuments.find(relatedDocument => relatedDocument.idDocument == $this.invoice.uuid);
                                    relatedPayment.isAvailable = true;
                                    relatedDocument.isAvailable = true;
                                } else {
                                    relatedPayment.relatedDocuments.forEach(document => {
                                        if (document.idDocument === $this.invoice.uuid) {
                                            relatedPayment.isAvailable = true;
                                            document.isAvailable = true;
                                        }
                                    });
                                }

                                $this.showAlertMessage(language[local].attention, `${ language[local][response.messageType]}, ${ language[local].reloadThePage }`, 'warning');

                                toastr.warning(`${ language[local][response.messageType]}, ${ language[local].reloadThePage }`, language[local].attention);
                                $btnActions.removeAttr('disabled');
                            } else {
                                $this.showAlertMessage(language[local].anErrorHasOccurred, language[local].tyrAgainErr, 'error');
                                toastr.error(`${ language[local].tryAgainError }.`, language[local].anErrorHasOccurred);
                                $btnActions.removeAttr('disabled');
                            }
                        },
                        error(xhr) {
                            if (xhr.status == 401) {
                                toastr.error(`${ language[local].accessUnauthorized }, ${ language[local].reloadThePage }`, language[local].anErrorHasOccurred);
                            } else {
                                toastr.error(language[local].tryAgainError, language[local].anErrorHasOccurred);
                            }

                            $this.showAlertMessage(language[local].anErrorHasOccurred, language[local].tyrAgainErr, 'error');
                            $btnActions.removeAttr('disabled');
                        }
                    });
                } else {
                    $('#payment-receipt-pdf-file-input').focus();
                }
            }
        },
        updatePdfFile() {
            let $this = this;
            let url = this.updateUrl.replace('PLACEHOLDER', $this.paymentReceipt.id);
            let formData = new FormData();
            let $btnActions = $('.btn-actions');
            $btnActions.prop('disabled', true);

            let $pdfFile = $('#payment-receipt-pdf-file-input')[0].files[0];

            $this.action = 'UPDATE';

            if ($pdfFile) {
                if ($pdfFile.type !== 'application/pdf') {
                    this.formError.pdfFile = true;
                } else {
                    Swal.fire({
                        icon: 'warning',
                        title: language[local].attention,
                        html: language[local].updatePdfQuestion,
                        showCancelButton: true,
                        cancelButtonText: language[local].no,
                        confirmButtonColor: $this.swalButtonColor,
                        confirmButtonText: language[local].yes,
                        reverseButtons: true
                    }).then(result => {
                        if (result.isConfirmed) {
                            formData.append('pdfFile[name]', $pdfFile.name);
                            formData.append('pdfFile[size]', $pdfFile.size);
                            formData.append('pdfFile[file]', $pdfFile);
                            formData.append('entityVersion', $this.paymentReceipt.entityVersion);

                            $.ajax({
                                url: url,
                                method: 'POST',
                                data: formData,
                                contentType: false,
                                processData: false,
                                success(response) {
                                    if (response.code === 'OK') {
                                        window.location.reload();
                                        $btnActions.removeAttr('disabled');
                                    } else if (response.code === 'NOK') {
                                        toastr.warning(`${ language[local][response.messageType] }, ${ language[local].reloadThePage }`, language[local].attention);
                                        $btnActions.removeAttr('disabled');
                                    } else {
                                        toastr.error(`${ language[local].tryAgainError }.`, language[local].anErrorHasOccurred);
                                        $btnActions.removeAttr('disabled');
                                    }
                                },
                                error(xhr) {
                                    if (xhr.status == 401) {
                                        toastr.error(`${ language[local].accessUnauthorized }, ${ language[local].reloadThePage }`, language[local].anErrorHasOccurred);
                                    } else {
                                        toastr.error(language[local].tryAgainError, language[local].anErrorHasOccurred);
                                    }

                                    $btnActions.removeAttr('disabled');
                                }
                            });
                        } else {
                            $('#payment-receipt-pdf-file-input').val(null);
                            $('#payment-receipt-pdf-file-name').text($this.paymentReceipt.pdf.name);
                            $btnActions.removeAttr('disabled');
                        }
                    });
                }
            }

            $btnActions.removeAttr('disabled');
        },
        deletePaymentReceipt() {
            if (!this.canDelete) {
                toastr.warning(language[local].deleteDisable, language[local].attention);
                return;
            }

            let $this = this;
            let url = this.deleteUrl.replace('PLACEHOLDER2', $this.payment.id).replace('PLACEHOLDER', $this.paymentReceipt.id);
            let relatedAmount = $this.invoice.uuid ? $this.relatedDocument.amountPaid : $this.paymentReceipt.relatedTotal;
            let entityVersion = $this.paymentReceipt.entityVersion;
            let $btnActions = $('.btn-actions');
            $btnActions.prop('disable', true);

            $('#payment-receipt-modal').modal('hide');

            let message = language[local].deletePaymentRelation;

            if (this.invoice.uuid) {
                message += `<br><em style="font-size:13px;"> ${ language[local].deleteRelatedDocumentRelation } </em>`;
            }

            $this.action = 'DELETE';

            try {
                Swal.fire({
                    icon: 'warning',
                    title: language[local].attention,
                    html: message,
                    showCancelButton: true,
                    cancelButtonText: language[local].cancel,
                    confirmButtonColor: '#dc3741',
                    confirmButtonText: language[local].delete,
                    reverseButtons: true
                }).then(result => {
                    if (result.isConfirmed) {
                        $.ajax({
                            url: url,
                            method: 'DELETE',
                            data: $this.invoice.uuid ? JSON.stringify({
                                id: $this.invoice.id, 
                                uuid: $this.invoice.uuid,
                                relatedAmount: relatedAmount,
                                paymentReceiptEntityVersion: entityVersion
                            }) : JSON.stringify({
                                relatedAmount: relatedAmount,
                                paymentReceiptEntityVersion: entityVersion
                            }),
                            success(response) {
                                if (response.code === 'OK') {
                                    window.location.reload();
                                } else if (response.code === 'NOK') {
                                    toastr.warning(`${ language[local][response.messageType] }, ${ language[local].reloadThePage }`, language[local].attention);
                                } else {
                                    toastr.error(`${ language[local].tryAgainError }.`, language[local].anErrorHasOccurred);
                                }
                            },
                            error(xhr) {
                                if (xhr.status == 401) {
                                    toastr.error(`${ language[local].accessUnauthorized }, ${ language[local].reloadThePage }`, language[local].anErrorHasOccurred);
                                } else {
                                    toastr.error(language[local].tryAgainError, language[local].anErrorHasOccurred);
                                }
                            }
                        });
                    }
                });
            } catch (error) {
                toastr.error(`${ language[local].tryAgainError }.`, language[local].anErrorHasOccurred);
            }

            $btnActions.removeAttr('disabled');
        },
        paymentReceiptValidator(uuid) {
            let $this = this;

            let data = {
                orderType: 'Payment',
                orderId: $this.payment.id,
                requiresXmlFile: $this.paymentReceipt.requiresXmlFile
            };

            if (uuid !== null && uuid != '') {
                data.uuid = uuid;
            } else {
                return Promise.failure();
            }

            return new Promise((resolve, failure) => {
                $.ajax({
                    url: $this.validateUrl,
                    method: 'GET',
                    data: data,
                    success(response) {
                        if (response.code === 'OK') {
                            $this.paymentReceiptExists = JSON.parse(response.exists);

                            if (response.exists) {
                                Swal.fire({
                                    icon: 'warning',
                                    title: language[local].attention,
                                    html: language[local].alreadyRegister,
                                    showCancelButton: true,
                                    cancelButtonText: language[local].no,
                                    confirmButtonColor: $this.swalButtonColor,
                                    confirmButtonText: language[local].yes,
                                    reverseButtons: true
                                }).then(result => {
                                    if (result.isConfirmed) {
                                        $this.paymentReceipt = Object.assign($this.paymentReceipt, response.invoice);

                                        let relatedPayment = $this.paymentReceipt.relatedPayments.find(relatedPayment => relatedPayment.paymentId == $this.payment.id);

                                        if (relatedPayment) {
                                            relatedPayment.relatedDocuments.forEach(document => {
                                                if (!relatedPayment.isAvailable && document.isAvailable && (document.idDocument === $this.invoice.uuid)) {
                                                    document.isSelected = true;
                                                    $this.paymentReceipt.relatedAmount = document.amountPaid;
                                                    $this.relatedDocument = document;

                                                    relatedPayment.isSelected = true;
                                                    relatedPayment.paymentId = $this.payment.id;
                                                    $this.relatedPayment = relatedPayment;
                                                    $this.hasRelatedPayment = true;
                                                }
                                            });
                                        } else {
                                            $this.paymentReceipt.relatedPayments.forEach(relatedPayment => {
                                                relatedPayment.relatedDocuments.forEach(document => {
                                                    if (document.isAvailable && !relatedPayment.paymentId && (document.idDocument === $this.invoice.uuid)
                                                        && (document.amountPaid == $this.payment.amount) && !$this.hasRelatedPayment) {
                                                        document.isSelected = true;
                                                        $this.paymentReceipt.relatedAmount = document.amountPaid;
                                                        $this.relatedDocument = document;

                                                        relatedPayment.isSelected = true;
                                                        relatedPayment.paymentId = $this.payment.id;
                                                        $this.relatedPayment = relatedPayment;
                                                        $this.hasRelatedPayment = true;
                                                    }
                                                });
                                            });
                                        }

                                        if (!$this.hasRelatedPayment) {
                                            $this.showAlertMessage(language[local].attention, language[local].noAvailablePayment, 'warning');
                                        } else {
                                            $this.action = 'RELATE';
                                        }

                                        $('#payment-receipt-pdf-file-name').text(response.invoice.pdf.name);
                                    } else {
                                        $this.paymentReceiptXmlFileClear();
                                        toastr.warning(language[local].paymentReceiptAlreadyExists, language[local].attention);
                                        failure();
                                    }
                                });
                            }

                            $this.canCreate = JSON.parse(response.canCreate);

                            if ($this.canCreate || $this.paymentReceiptExists) {
                                $this.hasValidXmlFile = true;
                            }

                            resolve();
                        } else if (response.message) {
                            toastr.warning(`${ language[local][response.messageType] }, ${ language[local].reloadThePage }`, language[local].attention);
                            $this.paymentReceiptXmlFileClear();
                            failure();
                        }
                    },
                    error(xhr) {
                        if (xhr.status == 401) {
                            toastr.error(`${ language[local].accessUnauthorized }, ${ language[local].reloadThePage }`, language[local].anErrorHasOccurred);
                        } else {
                            toastr.error(language[local].tryAgainError, language[local].anErrorHasOccurred);
                        }
                        
                        failure({ code: 401 });
                    }
                });
            });
        },
        getPaymentAndInvoice() {
            let $this = this;

            this.paymentReceipt.relatedPayments.forEach(relatedPayment => {
                if (relatedPayment.paymentId == $this.payment.id) {
                    relatedPayment.isSelected = true;
                    $this.relatedPayment = relatedPayment;
                    $this.hasRelatedPayment = true;
                    $this.hasValidXmlFile = true;
                }

                relatedPayment.relatedDocuments.forEach(document => {
                    if (relatedPayment.isSelected && (document.idDocument == $this.invoice.uuid)) {
                        if (document.isAvailable) {
                            $this.hasRelatedPayment = false;
                            $this.hasValidXmlFile = false;
                        } else {
                            document.isSelected = true;
                            $this.relatedDocument = document;
                        }
                    }
                });
            });

            if (!$this.hasRelatedPayment) {
                $this.showAlertMessage(language[local].paymentReceiptShowErrorTitle, `${ language[local].paymentReceiptShowErrorMessage }, ${ language[local].reloadThePage }`, 'warning');
            } else {
                $this.action = 'SHOW';
            }

            $('#payment-receipt-xml-file-name').text($this.paymentReceipt.xml.name);
            $('#payment-receipt-pdf-file-name').text($this.paymentReceipt.pdf.name);
            $('#download-xml-file').attr('href', $this.paymentReceipt.xml.url);
            $('#download-pdf-file').attr('href', $this.paymentReceipt.pdf.url);
        },
        canSave() {
            if (!this.isShow && this.validateInvoiceUuid && this.validatePaymentDate && this.validatePaymentAmount && this.validatePaymentCurrency && 
                this.validateIssuingData && this.validateRecipientData && this.canCreate) {
                return true;
            }

            return false;
        },
        getVoucherTypeName(type) {
            if (type.toLowerCase() == 'i') {
                return language[local].income;
            } else if (type.toLowerCase() == 'e') {
                return language[local].expense;
            } else if (type.toLowerCase() == 'p') {
                return language[local].paymentReceipt;
            }

            return '';
        },
        showAlertMessage(title, message, type) {
            if (type === 'warning') {
                this.showWarningAlert = true;
                this.showAlert = false;
            } else if (type === 'error') {
                this.showAlert = true;
                this.showWarningAlert = false;
            }

            this.optionAlert = {
                title: title,
                message: message
            };

            $('#payment-receipt-modal').animate({ scrollTop: 0 }, 'fast');
        }
    },
    computed: {
        validateInvoiceUuid() {
            if (this.relatedDocument.idDocument && !this.isShow) {
                return this.relatedDocument.idDocument === this.invoice.uuid;
            } else {
                return false;
            }
        },
        validateInvoiceSerial() {
            if (this.relatedDocument.serial && !this.isShow) {
                return this.relatedDocument.serial === this.invoice.serial;
            } else {
                return false;
            }
        },
        validateInvoiceFolio() {
            if (this.relatedDocument.folio && !this.isShow) {
                return this.relatedDocument.folio == this.invoice.folio;
            } else {
                return false;
            }
        },
        validatePaymentDate() {
            let $this = this;
            if (this.relatedPayment.paymentDate && !this.isShow) {
                return moment($this.relatedPayment.paymentDate).format('YYYY-MM-DD') === this.payment.paymentDate;
            } else {
                return false;
            }
        },
        validatePaymentAmount() {
            if (this.relatedDocument.amountPaid && !this.isShow) {
                return this.relatedDocument.amountPaid == this.payment.amount;
            } else {
                return false;
            }
        },
        validatePaymentCurrency() {
            if (this.relatedDocument.currency.code && !this.isShow) {
                return this.relatedDocument.currency.code === this.payment.currency.code;
            } else {
                return false;
            }
        },
        validateIssuingData() {
            if (this.paymentReceipt.issuing.name != '' && !this.isShow) {
                return this.paymentReceipt.issuing.taxId.trim() == this.invoice.issuing.taxId.trim() && 
                    this.paymentReceipt.issuing.name.trim() == this.invoice.issuing.name.trim();
            } else {
                return false;
            }
        },
        validateRecipientData() {
            if (this.paymentReceipt.recipient.name != '' && !this.isShow) {
                return this.paymentReceipt.recipient.taxId.trim() == this.invoice.recipient.taxId.trim() && this.paymentReceipt.recipient.name.trim() == this.invoice.recipient.name.trim();
            } else {
                return false;
            }
        }
    }
});

export default paymentReceiptModalComponent;
